const requiredData = [
  {
    icon: 'icon_lock',
    title: 'Authorization',
    content: 'Authorization to retrieve ELD data',
  },
  {
    icon: 'icon_location',
    title: 'Location Data',
    content: 'GPS location data',
  },
  {
    icon: 'icon_carrier',
    title: 'Vehicle Data',
    content: 'Critical vehicle data (Make, Model, VIN)',
  },
]

const insurerDataItems = [
  {
    icon: 'icon_lock',
    title: 'Authentication',
    content: 'Authentication to retrieve ELD data',
    dataKey: 'authenticationData',
  },
  {
    icon: 'icon_location',
    title: 'Location Data',
    content: 'GPS location and speed information',
    dataKey: 'locationData',
  },
  {
    icon: 'icon_carrier',
    title: 'Vehicle Data',
    content: 'Vehicle Identification Number, make model, year',
    dataKey: 'vehicleData',
  },
  {
    icon: 'icon_profile',
    title: 'Driver Data',
    content: 'Driver number, contact information',
    dataKey: 'driverData',
  },
  {
    icon: 'cob_safety',
    title: 'Safety Events Data',
    content: 'Harsh events, driving behaviors',
    dataKey: 'safetyEventsData',
  },
]

export { requiredData, insurerDataItems }
